import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import CardSimple from "@/components/CardSimple";
import UserRoleIcon from "@/components/UserRoleIcon";
import UserEdit from "@/features/Users/UserEdit";
import { useAuthorization } from "@/modules/authorization";
import { useSidePanel } from "@/modules/side-panel";

const UserOrganizationMainRole = ({ mainRole, user, loading }) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();
  const { canUpdate } = useAuthorization();

  const role = mainRole?.name?.split(".")[0];

  const handleClick = () => {
    openSidePanel({
      title: user.name,
      component: <UserEdit userId={user.id} />,
    });
  };

  return (
    <CardSimple
      title={t(`user:organizationRole.${role}.label`)}
      icon={<UserRoleIcon role={role} />}
      secondaryTitle={t("user:role")}
      loading={loading}
      extra={
        <Button
          size="small"
          icon={<EditOutlined />}
          onClick={handleClick}
          loading={loading}
          disabled={!canUpdate(user)}
        >
          {t("global:edit")}
        </Button>
      }
    >
      {t(`user:organizationRole.${role}.description`)}
    </CardSimple>
  );
};

UserOrganizationMainRole.propTypes = {
  mainRole: PropTypes.object,
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default UserOrganizationMainRole;
